import store from '../store';
import Vue from 'vue';
import * as types from '../store/mutation-types';
import { EventBus } from '../api/eventbus';
import AuthService from '../services/auth.service';
import StatsService from '../services/stats.service';
import loop from './loop';

let wasConnectedBefore = false,
    disconnectMessage  = '';

export default {
    connect() {
        store.commit(types.INITIALIZE, true);
        if (wasConnectedBefore) {
            if (disconnectMessage !== null) {
                EventBus.$emit('clearMessage', disconnectMessage);
                disconnectMessage = null;
            }
            EventBus.$emit('addMessage', {
                type:        'info',
                text:        Vue.i18n.translate('CONNECTION_FOUND'),
                headline:    Vue.i18n.translate('CONNECTION_FOUND_HEADLINE'),
                dismissible: true,
                check:       false,
                timeout:     5000
            });
        }
        wasConnectedBefore = true;
    },
    gameInit(data) {
        const auth       = new AuthService(),
            lastOnline = Vue.localStorage.get('lastOnline') || 0;
        auth.getUser();
        store.commit({
            type: types.SET_KEY,
            key:  data.key
        });
        store.commit({
            type:    types.SET_VERSION,
            version: data.serverVersion
        });
        Vue.i18n.set(store.state.game.language);
        if (lastOnline > 0) {
            const secondsForProduction = Math.floor((Date.now() - lastOnline) / 1000);
            if (secondsForProduction >= 0) {
                store.commit('CALCULATE_INCOME_WHILE_GONE', { secondsForProduction });
            }
        }
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
                Vue.localStorage.set('lastOnline', Date.now());
            }
        });
        window.addEventListener('pagehide', () => {
            Vue.localStorage.set('lastOnline', Date.now());
        });
        StatsService.postStats(loop.collectStats());
    },
    disconnect() {
        if (wasConnectedBefore) {
            store.commit(types.INITIALIZE, false);
            EventBus.$emit('addMessage', {
                type:        'danger',
                text:        Vue.i18n.translate('CONNECTION_LOST'),
                headline:    Vue.i18n.translate('CONNECTION_LOST_HEADLINE'),
                dismissible: true,
                check:       false,
                timeout:     false,
                cb:          msg => {
                    disconnectMessage = msg;
                }
            });
        }
    },
    tick() {
        loop.onTick();
    }
};
